module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r2r6n9r-dbf3f229d759f5716f17095b7a4e0681.svg";